import { ReactNode } from 'react';
import NavigationButton, { NavigationButtonProps } from './NavigationButton';

export interface SagaNavigationProps
  extends Omit<NavigationButtonProps, 'icon'> {
  children?: ReactNode;
}

export const SagaNavigation = ({
  label,
  id,
  onClick,
  active = false,
  children,
}: SagaNavigationProps) => {
  return (
    <NavigationButton
      icon='material-symbols:book-4'
      label={label}
      id={id}
      onClick={onClick}
      active={active}
    >
      {children}
    </NavigationButton>
  );
};

export default SagaNavigation;
